/* Modular Outdoor Seating Guide – newsletter form hydration + inline "Thank you!" */
(function () {
  var tpl = document.getElementById('ms-form-tpl');
  if (!tpl) return;
  document.querySelectorAll('[data-ms-form-slot]').forEach(function (slot) {
    var frag = tpl.content.cloneNode(true);
    var form = frag.querySelector('form.ms-form');
    var title = slot.getAttribute('data-title');
    if (title) {
      var h = document.createElement('h2');
      h.className = 'ms-h2sm';
      h.textContent = title;
      form.insertBefore(h, form.firstChild);
    }
    slot.replaceWith(frag);
  });
  document.querySelectorAll('form.ms-form').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      form.classList.remove('has-err');
      fetch(form.getAttribute('action') || '/contact#contact_form', {
        method: 'POST',
        body: new FormData(form),
        headers: { Accept: 'text/html' }
      }).then(function (r) {
        if (r.url && r.url.indexOf('/challenge') > -1) { form.submit(); return; }
        if (r.ok) { form.classList.add('is-done'); } else { form.classList.add('has-err'); }
      }).catch(function () { form.classList.add('has-err'); });
    });
  });
})();
